
(function () {
  // ——— Carga segura de UMD si no existe (por si el CDN se tarda) ———
  function ensureEmblaUMD() {
    if (typeof window.EmblaCarousel === 'function') return Promise.resolve();
    if (window.__emblaLoadingPromise) return window.__emblaLoadingPromise;

    const CDN_URL = 'https://cdn.jsdelivr.net/npm/embla-carousel@8.1.6/embla-carousel.umd.min.js';
    window.__emblaLoadingPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = CDN_URL;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('No se pudo cargar Embla UMD'));
      document.head.appendChild(s);
    });
    return window.__emblaLoadingPromise;
  }

  class XEmbla extends HTMLElement {
    connectedCallback() {
      this._init();
      // Theme Editor: reinit al recargar sección
      this._onSectionLoad = (e) => {
        if (e.detail?.sectionId && this.id?.includes(e.detail.sectionId)) this._init(true);
      };
      this._onSectionUnload = (e) => {
        if (e.detail?.sectionId && this.id?.includes(e.detail.sectionId)) this._destroy();
      };
      document.addEventListener('shopify:section:load', this._onSectionLoad);
      document.addEventListener('shopify:section:unload', this._onSectionUnload);
    }

    disconnectedCallback() {
      this._destroy();
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
      document.removeEventListener('shopify:section:unload', this._onSectionUnload);
    }

    async _init(force) {
      if (this._api && !force) return;
      await ensureEmblaUMD();

      // Config por data-attributes
      const gap = Number(this.dataset.gap || 16);
      this.style.setProperty('--gap', `${gap}px`);
      this._slidesM = Number(this.dataset.slidesM || 1);
      this._slidesT = Number(this.dataset.slidesT || 2);
      this._slidesD = Number(this.dataset.slidesD || 3);
      this._align   = this.dataset.align || 'start';
      this._loop    = this.dataset.loop === 'true';
      this._autoplay = this.dataset.autoplay === 'true';
      this._autoplayInterval = Number(this.dataset.autoplayInterval || 4000);

      // Viewport + container
      this._viewport = this.querySelector('.embla__viewport');
      this._container = this.querySelector('.embla__container');
      if (!this._viewport || !this._container) return;

      // Calcular slides per view por breakpoint (m: <750, t: <1200, d: >=1200)
      const setSPV = () => {
        const w = this.clientWidth || window.innerWidth;
        let spv = this._slidesM;
        if (w >= 1200) spv = this._slidesD;
        else if (w >= 750) spv = this._slidesT;
        this.style.setProperty('--spv', spv);
      };
      setSPV();
      this._resizeHandler = () => { setSPV(); this._api && this._api.reInit(); };
      window.addEventListener('resize', this._resizeHandler);

      // Embla
      this._api = window.EmblaCarousel(this._viewport, { align: this._align, loop: this._loop });

      // Flechas
      const prevBtn = this.querySelector('.embla__arrow--prev');
      const nextBtn = this.querySelector('.embla__arrow--next');
      const toggleArrows = () => {
        if (!prevBtn || !nextBtn) return;
        this._api.canScrollPrev() ? prevBtn.removeAttribute('disabled') : prevBtn.setAttribute('disabled','');
        this._api.canScrollNext() ? nextBtn.removeAttribute('disabled') : nextBtn.setAttribute('disabled','');
      };
      const scrollPrev = () => this._api.scrollPrev();
      const scrollNext = () => this._api.scrollNext();
      prevBtn?.addEventListener('click', scrollPrev);
      nextBtn?.addEventListener('click', scrollNext);
      this._cleanupArrows = () => {
        prevBtn?.removeEventListener('click', scrollPrev);
        nextBtn?.removeEventListener('click', scrollNext);
      };
      this._api.on('init', toggleArrows).on('reInit', toggleArrows).on('select', toggleArrows);

      // Dots
      const dotsNode = this.querySelector('.embla__dots');
      let dotNodes = [];
      const buildDots = () => {
        if (!dotsNode) return;
        dotsNode.innerHTML = this._api.scrollSnapList()
          .map(() => '<button class="embla__dot" type="button"></button>').join('');
        dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
        dotNodes.forEach((btn, i) => btn.addEventListener('click', () => this._api.scrollTo(i)));
        toggleDots();
      };
      const toggleDots = () => {
        if (!dotNodes.length) return;
        const prev = this._api.previousScrollSnap();
        const sel  = this._api.selectedScrollSnap();
        dotNodes[prev]?.classList.remove('embla__dot--selected');
        dotNodes[sel]?.classList.add('embla__dot--selected');
      };
      this._api.on('init', buildDots).on('reInit', buildDots).on('select', toggleDots);

      // Autoplay (opcional)
      if (this._autoplay) {
        let timer = null;
        const play = () => {
          stop();
          timer = setInterval(() => this._api && this._api.scrollNext(), this._autoplayInterval);
        };
        const stop = () => timer && (clearInterval(timer), timer = null);
        const pauseOnInteract = () => { stop(); this.addEventListener('mouseleave', play, { once: true }); };

        this.addEventListener('mouseenter', stop);
        this.addEventListener('touchstart', stop, { passive: true });
        this.addEventListener('pointerdown', stop, { passive: true });
        this.addEventListener('focusin', stop);
        this.addEventListener('pointerup', pauseOnInteract);
        this._autoplayCleanup = () => {
          stop();
          this.removeEventListener('mouseenter', stop);
          this.removeEventListener('touchstart', stop);
          this.removeEventListener('pointerdown', stop);
          this.removeEventListener('focusin', stop);
          this.removeEventListener('pointerup', pauseOnInteract);
        };
        play();
      }

      // init listo
      // console.log('[x-embla] ready', this.id);
    }

    _destroy() {
      window.removeEventListener('resize', this._resizeHandler);
      this._autoplayCleanup?.();
      this._cleanupArrows?.();
      this.querySelector('.embla__dots') && (this.querySelector('.embla__dots').innerHTML = '');
      if (this._api) { this._api.destroy(); this._api = null; }
    }
  }

  customElements.get('x-embla') || customElements.define('x-embla', XEmbla);


  // Para cada details .mega-menu, mide su <summary> y alinea el panel
  document.querySelectorAll('.header__inline-menu details.mega-menu').forEach((dd) => {
    const summary = dd.querySelector('summary');
    const panel = dd.querySelector('.mega-menu__content');

    /* console.log('------.panle', panel); */

    function setPanelHeight() {
      // getBoundingClientRect es estable; redondeo para evitar sub-píxeles raros
      const h = Math.round(panel.getBoundingClientRect().height || panel.scrollHeight);
      dd.style.setProperty('--panel-height', `${h}px`);
      console.log('------.panle', h);
    }

    function placePanel() {
      const r = summary.getBoundingClientRect();
      // top del panel = bottom del summary (respecto al viewport)
      dd.style.setProperty('--header-bottom', `${Math.round(r.bottom)}px`);
      setPanelHeight();

      // empujar el contenido interno hasta el left del summary
      panel.style.setProperty('--trigger-left', `${Math.round(r.left)}px`);
    }

    // Al abrir/cerrar
    summary.addEventListener('click', () => {
      // Espera a que <details> cambie a [open]
      requestAnimationFrame(() => { if (dd.open) placePanel(); });
    });

    // Recalcula en resize/scroll (por si el header es sticky y cambia posición)
    ['resize', 'scroll'].forEach(ev =>
      window.addEventListener(ev, () => { if (dd.open) placePanel(); }, { passive: true })
    );
  });

  // (Opcional) cerrar al hacer click en el overlay
  document.addEventListener('click', (e) => {
    const dd = e.target.closest('details.mega-menu');
    if (dd && dd.open && e.target === dd) dd.removeAttribute('open');
  });

  function setSelectedText(root, optionName, value) {
    // 1) Target ideal: data-selected-value="OptionName"
    const exactTargets = root.querySelectorAll(`[data-selected-value="${optionName}"]`);

    if (exactTargets.length) {
      exactTargets.forEach((el) => (el.textContent = value));
      return;
    }

    // 2) Fallback A: si solo hay un [data-selected-value] sin nombre, úsalo
    const unnamedTargets = root.querySelectorAll('[data-selected-value]:not([data-selected-value=""])');
    const emptyAttrTargets = root.querySelectorAll('[data-selected-value=""]');

    if (!unnamedTargets.length && emptyAttrTargets.length === 1) {
      emptyAttrTargets[0].textContent = value;
      return;
    }

    // 3) Fallback B: si hay exactamente un [data-selected-value] en total, úsalo
    const allTargets = root.querySelectorAll('[data-selected-value]');
    if (allTargets.length === 1) {
      allTargets[0].textContent = value;
    }
  }

  // Delegación: cubre páginas con múltiples productos/sections y contenido dinámico
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    // Solo nos interesan radios y selects
    const isRadio = t.tagName === 'INPUT' && t.type === 'radio';
    const isSelect = t.tagName === 'SELECT';
    if (!isRadio && !isSelect) return;

    // Debe estar dentro de un <variant-selects>
    const root = t.closest('variant-selects');
    if (!root) return;

    const optionName = t.name || '';            // p.ej. "Size", "Color"
    const value = isSelect ? t.value : t.value; // ambos casos usan .value

    setSelectedText(root, optionName, value);
  });

  // Inicializa en carga (por si la página entra con una variante preseleccionada)
  function initSelectedValues() {
    document.querySelectorAll('variant-selects').forEach((root) => {
      // Radios: toma el :checked de cada fieldset
      root.querySelectorAll('fieldset').forEach((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) setSelectedText(root, checked.name || '', checked.value);
      });
      // Selects: toma el value actual
      root.querySelectorAll('select').forEach((sel) => {
        setSelectedText(root, sel.name || '', sel.value);
      });
    });
  }

  // Ejecuta al final del frame para asegurar que el DOM del producto ya está
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelectedValues);
  } else {
    initSelectedValues();
  }

})();
